import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useState, useContext } from 'react';
import { AppContext } from '../../../../Context';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../../../firebase/firebase';
import { Container, Row, Col, Form, Button, ListGroup, ListGroupItem, FormGroup, FormControl, Label } from 'react-bootstrap';
import Swal from 'sweetalert2';


const M8_Ejercicio9 = ({ cerrarModal }) => {

    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [respuestas, setRespuestas] = useState({
        // Raíz: physis = naturaleza
        
        
        cabestro: '',
        cabestrillo: '',
        capitulo: '',
        capitel: '',
        decapitar: '',
        capataz: '',
        caotico: '',
        caducar: '',
        caos: '',
        cariño: '',
        querido: '',
        querer: '',
        artefacto: '',
        ipsofacto: '',
        fabrica: '',
        fabricar: '',

    
        

    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setRespuestas(prevRespuestas => ({
            ...prevRespuestas,
            [name]: value
        }));
    };


    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (!Object.values(respuestas).every(value => value.trim() !== '')) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Todos los campos deben estar llenos antes de enviar la evaluación.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        try {
            await addDoc(collection(db, "evaluaciones"), {
                userId: currentUser.uid,
                nombre: "Ejercicio de Comprensión - Ejercicio 9",
                nivel: "Intermedio",
                modulo: "8",
                createdAt: new Date(),
                tipo: "Texto libre",
                respuestas
            });
            Swal.fire({
                title: '¡Evaluación Enviada!',
                text: 'Resultados enviados con éxito.',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Excelente'
            }).then((result) => {
                if (result.isConfirmed) {
                    cerrarModal();  // Cierra la modal al confirmar la alerta
                }
            });
        } catch (error) {
            console.error("Error al enviar las respuestas: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al enviar las respuestas.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar'
            });
        }
    };

    return (
        <div className="container mt-4">
            <h3>Nivel Intermedio</h3>
            <h3>Módulo 8 - Ejercicio 9</h3>
            <h5>Ejercicio de Comprensión</h5>
            <p><strong> Raíces Latinas</strong></p>


            <Row>
                <Col md={6}>

                    <div className='border p-3'>

                        <p><strong>Raíz: cápitis = parte más alta del cuerpo, cabeza</strong></p>
                        <p>Per cápita: por cabeza <br></br>
                        Capota: gorro para la cabeza <br></br>
                        Capitolio: edificio cabeza, principal <br></br>
                        Capitón: cabezón</p>



                        <Form>
                            
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Cabestro</div>
                                <FormControl
                                    type="text"
                                    name="cabestro"
                                    value={respuestas.cabestro}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Cabestrillo</div>
                                <FormControl
                                    type="text"
                                    name="cabestrillo"
                                    value={respuestas.cabestrillo}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Capítulo</div>
                                <FormControl
                                    type="text"
                                    name="capitulo"
                                    value={respuestas.capitulo}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Capitel</div>
                                <FormControl
                                    type="text"
                                    name="capitel"
                                    value={respuestas.capitel}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Decapitar</div>
                                <FormControl
                                    type="text"
                                    name="decapitar"
                                    value={respuestas.decapitar}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Capataz</div>
                                <FormControl
                                    type="text"
                                    name="capataz"
                                    value={respuestas.capataz}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>

                        <br />

                        <Form className='border p-3'>




                            <p><strong>Raíz: cado = caer, caerse</strong></p>
                            <p>Caesum = que cae, derribar, tumbar, herir a muerte</p>

                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Caótico</div>
                                <FormControl
                                    type="text"
                                    name="caotico"
                                    value={respuestas.caotico}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Caducar</div>
                                <FormControl
                                    type="text"
                                    name="caducar"
                                    value={respuestas.caducar}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <div className="text-muted small mb-1">Caos</div>
                                <FormControl
                                    type="text"
                                    name="caos"
                                    value={respuestas.caos}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Form>
                        <br />

                      
                         </div>
                </Col>
                <Col md={6}>
                    <div>
                       
                    <Form className='border p-3'>

<p><strong>Raíz: Campus = campo, llano, llanura</strong></p>
<p>Campesino, acampar, campo, <br />
campaña, campestre <br />
Campaña: Expedición con un propósito, originalmente al campo. <br />
Campañol: ratón de campo </p>
</Form>
<br />


<Form className='border p-3'>

<p><strong>Raíz: caritas = carestía, precio, efecto, ternura.</strong></p>

<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Cariño</div>
    <FormControl
        type="text"
        name="cariño"
        value={respuestas.cariño}
        onChange={handleChange}
    />
</FormGroup>
<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Querido</div>
    <FormControl
        type="text"
        name="querido"
        value={respuestas.querido}
        onChange={handleChange}
    />
</FormGroup>
<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Querer</div>
    <FormControl
        type="text"
        name="querer"
        value={respuestas.querer}
        onChange={handleChange}
    />
</FormGroup>

</Form>
<br />

<Form className='border p-3'>

<p><strong>Raíz: facto, Facio, Factum = hacer, hecho, construir, hechura.</strong></p>


<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Artefacto</div>
    <FormControl
        type="text"
        name="artefacto"
        value={respuestas.artefacto}
        onChange={handleChange}
    />
</FormGroup>
<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Ipso facto</div>
    <FormControl
        type="text"
        name="ipsofacto"
        value={respuestas.ipsofacto}
        onChange={handleChange}
    />
</FormGroup>
<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Fábrica</div>
    <FormControl
        type="text"
        name="fabrica"
        value={respuestas.fabrica}
        onChange={handleChange}
    />
</FormGroup>
<FormGroup className="mb-3">
    <div className="text-muted small mb-1">Fabricar</div>
    <FormControl
        type="text"
        name="fabricar"
        value={respuestas.fabricar}
        onChange={handleChange}
    />
    <p>Factito: hacer con frecuencia, hábito.</p>
</FormGroup>

</Form>   




                    </div>
                </Col>
                <Button onClick={enviarResultados} variant="primary">Enviar Resultados</Button>
            </Row>
        </div>
    );
};




export default M8_Ejercicio9;
